import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const MassSpecPage = () => {
  return <TechnicalServicePage serviceKey="massSpec" />
}

export default MassSpecPage
